import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import '../assets/sass/index.sass';
import logo from '../assets/img/logo.png';

const WIDGET_API_URL = 'https://backend.estate.hart-digital.com';

const WIDGET_API_STAGE_URL = 'https://backend-stage.estate.hart-digital.com';

const createWidget = async () => {
  const searchParams = (new URL(document.location)).searchParams;
  const planId = searchParams.get("id");
  const env = searchParams.get("env");

  const widgetApiHandler = new ApiStore(env === 'stage' ? WIDGET_API_STAGE_URL : WIDGET_API_URL)

  const planData = await widgetApiHandler.loadWidgetData(planId);
  const options = {
    ...planData.parsed,
    API_URL: env === 'stage' ? WIDGET_API_STAGE_URL : WIDGET_API_URL,
    rotationMode: rotationModes.DEFAULT,
    locale: 'en',
    logo: logo,
    tabs: ['panorama', 'plan', 'rotation'],
    dictionaryOverrides: {
      'made-by-link': 'https://cloferssales.com',
      'made-by-text': 'Clofers Sales',
      'instructions-hint-text': `Actual finishes and external views may vary; images are for illustrative purposes only.\n\nTatsächliche Ausführungen und Außenansichten können abweichen; Abbildungen dienen nur zu Illustrationszwecken.\n\nDe werkelijke afwerking en buitenaanzichten kunnen afwijken; de afbeeldingen dienen uitsluitend ter illustratie.`,

    },
  }

  new Widget('#widget', options);
}

createWidget();
